import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSodium } from '@heivol-locker/crypto';
import { App } from './App';
import './index.css';

/** Apply the saved (or OS-preferred) theme ASAP. Runs as module JS — no inline
 *  script — so CSP `script-src 'self'` stays clean (INV-11). Read order matches
 *  the canonical SiteHeader contract's anti-FOUC bootstrap: the cross-surface
 *  `hv-theme` cookie (set by lib/theme.ts on `.heivol.com`, so a theme chosen on
 *  another heivol surface carries over) → localStorage → OS preference. */
function applyStoredTheme(): void {
  try {
    const cookie = document.cookie.match(/(?:^|; )hv-theme=(light|dark)(?:;|$)/);
    const stored = cookie ? cookie[1] : localStorage.getItem('hv-theme');
    const theme =
      stored === 'light' || stored === 'dark'
        ? stored
        : window.matchMedia('(prefers-color-scheme: dark)').matches
          ? 'dark'
          : 'light';
    document.documentElement.setAttribute('data-theme', theme);
  } catch {
    /* storage / matchMedia unavailable */
  }
}

async function bootstrap(): Promise<void> {
  applyStoredTheme();
  // libsodium must be ready before any Argon2id/XChaCha20 call.
  await initSodium();
  const el = document.getElementById('root');
  if (el === null) {
    throw new Error('missing #root');
  }
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
